import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Select, message, Checkbox } from "antd";
import { binService, companyService } from "_services";

function Search(props) {
  const [addressLoading, setAddressLoading] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    getStoreAddresses();
  }, []);

  const getStoreAddresses = () => {
    setAddressLoading(true);
    companyService
      .getSuggestion("?companyTypeCodes=STORE")
      .then((x) => {
        setAddressLoading(false);
        if (x.content && x.content.length === 1) {
          setAddressLoading(true);
          companyService
            .getById(x.content[0].id)
            .then((x) => {
              setAddressLoading(false);
              setAddresses(x.content.addresses);
              if (x.content.addresses.length === 1) {
                form.setFieldsValue({
                  storeLocationId: x.content.addresses[0].id,
                });
              }
            })
            .catch((errorInfo) => {
              setAddressLoading(false);
            });
        }
      })
      .catch((errorInfo) => {
        setAddressLoading(false);
        message.error(`${errorInfo}`);
      });
  };

  const onFinish = (values) => {
    props.showSearchLoading(true);
    let searchParams = "?isParent=1";
    if (values.code) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `code=${encodeURIComponent(values.code)}`;
    }
    if (values.name) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `name=${encodeURIComponent(values.name)}`;
    }
    /* if (values.storeId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `storeId=${encodeURIComponent(values.storeId)}`;
    } */
    if (values.storeLocationId) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `storeLocationId=${encodeURIComponent(
        values.storeLocationId
      )}`;
    }
    if (values.isEmpty) {
      searchParams += searchParams.indexOf("?") === -1 ? "?" : "&";
      searchParams += `isEmpty=${encodeURIComponent(values.isEmpty)}`;
    }
    binService
      .search(searchParams)
      .then((data) => {
        props.onSearchResults(data.content, null, searchParams);
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([], null, searchParams);
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={5}>
          <Form.Item name="code" label="Code">
            <Input placeholder="Code" allowClear />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="name" label="Name">
            <Input placeholde="Name" allowClear />
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="isEmpty" valuePropName="checked">
            <Checkbox>Empty Bin</Checkbox>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item name="storeLocationId" label="Store Location">
            <Select
              placeholder="Please select"
              loading={addressLoading}
              allowClear
            >
              {addresses.length > 0 &&
                addresses.map((t) => (
                  <Select.Option value={t.id} key={t.id}>
                    {t.address}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default Search;
